import {
  boldBodyLargeTypography,
  Button,
  Modal,
  Typography,
} from '@leaftrade/leaftrade-component-library';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useStorefrontState } from '../../../../hooks/useReduxState';
import { togglePrivacyPolicyModal } from '../../../../store/actions/storefrontActions';
import PrivacyPolicy from '../../../routes/PrivacyPolicy';

const PrivacyPolicyModal = () => {
  const dispatch = useDispatch();
  const { checkout } = useStorefrontState();
  const { privacyPolicyModal } = checkout;

  const PrivacyPolicyModalJsx = {
    actions: (
      <>
        <Button
          onClick={() => {
            dispatch(togglePrivacyPolicyModal({ isOpen: false }));
          }}
        >
          Close
        </Button>
      </>
    ),
    body: <PrivacyPolicy />,
    header: (
      <Typography bodyStyle={boldBodyLargeTypography} gutterBottom>
        Privacy Policy
      </Typography>
    ),
  };

  return (
    <Modal
      actions={PrivacyPolicyModalJsx.actions}
      header={PrivacyPolicyModalJsx.header}
      open={privacyPolicyModal.isOpen}
      testingId='privacy-policy-modal--component--div'
    >
      {PrivacyPolicyModalJsx.body}
    </Modal>
  );
};

export default PrivacyPolicyModal;
